<template>
  <div>
    <nav-header ref="navHeader"
                v-bind:showSearch="p_showSearch"
                v-bind:loginModalFlag="p_loginModalFlag"
                v-bind:showNavbar="p_showNavbar"
                v-on:showLoginModal="p_showLoginModal"
                v-on:closeLoginModal="p_closeLoginModal"
    ></nav-header>
    <nav-bread>
      <span style="margin-right:10px;" slot="mine">个人中心</span>
      <!--<span style="margin-right:10px;" slot="orderList">我的订单</span>-->
    </nav-bread>
    <div class="container">
      <!--pc端-->
      <el-container>
        <div class="biaot"><p class="mshow">个人中心&nbsp;&nbsp;>&nbsp;&nbsp; 我的报告</p>
          <nav-left v-bind:activeIndex="p_activeIndex"></nav-left>
        </div>
        <el-container style="margin:10px 0 50px 20px;">

          <el-header class="mhide">我的报告


          </el-header>

          <!--<div class="a" v-if="isShowMedical"><router-link to="/mine/myMediaclReport">查看高诊无忧的报告 >> </router-link></div>-->
          <el-main v-loading="loading">
            <div class="myseh">
              <el-col :span="12">
                <el-dropdown trigger="click" @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{dateRange}}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="(item,index) in dateRangeList" :key="index" :command="item.key">
                      {{item.value}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </el-col>
              <div class="souright">

                <el-input
                  v-model="keyword"
                  placeholder="请输入搜索内容"

                  @input="inputKey"
                  @keyup.enter.native="search"
                  clearable>
                  <!--<a
                    herf="javascript:;"
                    class="el-icon-search"
                    slot="suffix"
                    @click="search">
                  </a>-->
                </el-input><el-button type="primary" @click="search">搜索
              </el-button>

              </div>
            </div>



            <div class="order-item" v-for="(item,index) in reportList">
              <div class="order-item-title">
                采样器编号：{{item.snCode}}
              </div>
              <el-table
                :data="item.itemReportList"
                border
                style="width: 100%">
                <!--<el-table-column-->
                <!--prop="snCode"-->
                <!--label="采样器编号"-->
                <!--width="150">-->
                <!--</el-table-column>-->
                <el-table-column
                  prop="itemName"
                  label="商品名称"
                  align="center">
                </el-table-column>
                <el-table-column
                  prop="realName"
                  label="姓名"
                  align="center">
                </el-table-column>
                <el-table-column
                  label="操作"
                  align="center">
                  <template slot-scope="scope">
                    <span class="state" v-if="item.sampleStatus==0">待收样</span>
                    <span class="state" v-if="item.sampleStatus==1">待检测</span>
                    <span class="state" v-if="item.sampleStatus==2">检测完成</span>

                  </template>
                </el-table-column>
              </el-table>
              <div class="order-item-footer">
                <div class="foots">
                  <div class="footz">{{item.addTime}}</div>    <div class="footy"> <el-button
                  @click.native.prevent="downloadReport(item)"
                  type="primary"
                  size="small"
                  v-if="item.sampleStatus==2">
                  查看报告
                </el-button></div>
                </div>
              </div>
            </div>



            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="limit"
              layout="prev, pager, next, jumper"
              :total="totalCount"
              v-if="reportList.length"
              style="text-align:center;margin-top: 20px;">
            </el-pagination>
            <div class="empty" v-if="reportList.length==0 && !loading">
              当前没有报告信息哦
            </div>
          </el-main>

        </el-container>
      </el-container>
    </div>
    <!--移动端-->
    <div class="mshow">
      <!--底部导航-->
      <tabbar :selected="selected" :tabs='tabs'></tabbar>
    </div>
  </div>
</template>

<script>
  import '@/assets/css/index.css'
  import NavLeft from '@/components/NavLeft.vue'
  import NavHeader from '@/components/Header'
  import NavBread from '@/components/Bread.vue'
  import {getCookie,IsPC} from "../../util/util";
  import '@/assets/css/index.css'
  import axios from "axios"
  import Tabbar from '@/components/Tabbar.vue'

  export default {
    name: "my-report",
    data() {
      return {
        p_activeIndex: "3",
        p_showSearch: true,
        p_loginModalFlag: false,
        p_showNavbar: true,
        limit: 7,
        page: 1,
        reportList: [],
        isChannel: true,
        loading: true,
        keyword: "",
        totalCount: 0,
        totalPage: 0,
        currentPage: 1,
        isShowMedical: false,
        selected: "Mine",
        tabs: [
          require("@/assets/hose_grey.png"),
          require("@/assets/shopping_grey.png"),
          require("@/assets/me_Filled.png")
        ],
        //查询时间段
        beginTime: '',
        dateRangeList: [
          {
            key: '',
            value: '不限时间'
          },
          {
            key: '1week',
            value: '近一周'
          },
          {
            key: '1month',
            value: '近一个月'
          },
          {
            key: '3month',
            value: '近三个月'
          },
          {
            key: '6month',
            value: '近半年'
          },
          {
            key: '1year',
            value: '近一年'
          }
        ],
        dateRange: '不限时间',
      }
    },
    components: {
      NavLeft,
      NavHeader,
      NavBread,
      Tabbar,
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
    },
    mounted() {
      if (getCookie("_token")) {
        // let time = new Date(((new Date()).getTime() - (365 / 4 * 24 * 3600 * 1000)));
        // this.beginTime = time.getFullYear() + '-' + (time.getMonth() + 1) + '-' + time.getDate();

        if (this.user.isChannel == 1 || this.user.isChannel == 2) {
          this.isChannel = true
        } else {
          this.isChannel = false
        }
        this.getReportList()
        // this.getMedicalReportList()
      } else {
        this.$message({
          showClose: true,
          message: '登录信息失效,请重新登录',
          type: 'error'
        });
        this.p_showLoginModal()
      }
    },
    methods: {
      p_showLoginModal() {
        this.p_loginModalFlag = true
      },

      p_closeLoginModal() {
        this.p_loginModalFlag = false
        if (this.user.isChannel == 1 || this.user.isChannel == 2) {
          this.isChannel = true
        } else {
          this.isChannel = false
        }
        this.getReportList()
        // this.getMedicalReportList()
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },

      handleCurrentChange(val) {
        this.page = val
        console.log(typeof val)
        this.getReportList(this.channel)
        console.log(`当前页: ${val}`);
      },

      downloadReport(item) {
        let url = item.reportUrl
        if (!IsPC()) {
          if (item.reportUrl.indexOf('.pdf') > 0) {
            url = item.localUrl
          }
        }
        let timestamp = new Date().getTime()
        window.open(url + '?t=' + timestamp)
      },
      getReportList() {
        axios.get("/jys/sample/list", {
          params: {
            limit: this.limit,
            page: this.page,
            itemName: this.keyword,
            beginTime: this.beginTime
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((respose) => {
          this.loading = false
          let res = respose.data
          if (res.code == 0) {
            let reportList = res.page.list
            this.totalPage = res.page.totalPage
            this.totalCount = res.page.totalCount
            reportList.map((item, index, arr) => {
              return arr[index].itemReportList = [item]
            })
            this.reportList = reportList


          } else if (res.code == 401) {
            this.loading = false
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },
      getMedicalReportList() {
        axios.get("/jys/sample/medicalList", {
          params: {
            limit: this.limit,
            page: this.page,
            itemName: this.keyword
          },
          headers: {
            "Content-Type": "application/json",
            'token': getCookie("_token")
          }
        }).then((respose) => {
          this.loading = false
          let res = respose.data
          if (res.code == 0) {
            if (res.page.list.length == 0) {
              this.isShowMedical = false
            } else {
              this.isShowMedical = true
            }

          } else if (res.code == 401) {
            this.$message({
              showClose: true,
              message: '登录信息失效,请重新登录',
              type: 'error'
            });
            this.$refs.navHeader.logout()
          }
        })
      },

      //搜索
      inputKey() {
        console.log(this.keyword)
        if (this.keyword.length == 0) {
          this.page = 1
          this.currentPage = 1
          this.getReportList()
        }
      },
      clearKey() {
        this.keyword = "";
        this.page = 1;
        this.currentPage = 1
        this.getReportList();
      },
      search() {
        this.page = 1;
        this.currentPage = 1
        this.getReportList()
      },

      //根据时间段搜索
      handleCommand(command) {
        // 先获取当前时间
        let curDate = (new Date()).getTime();
        let pastResult = '';

        if(command){
          if(command == '1week'){
            //近一周
            this.dateRange = '近一周'
            let dateTemp = 7 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;  // 毫秒单位

          }else if(command == '1month'){
            //近一个月
            this.dateRange = '近一个月'
            let dateTemp = 365 / 12 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '3month'){
            //近三个月
            this.dateRange = '近三个月'
            let dateTemp = 365 / 4 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '6month'){
            //近半年
            this.dateRange = '近半年'
            let dateTemp = 365 / 2 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }else if(command == '1year'){
            //近一年
            this.dateRange = '近一年'
            let dateTemp = 365 * 24 * 3600 * 1000;
            pastResult = curDate - dateTemp;

          }

          // 日期函数，定义起点为半年前
          let pastDate = new Date(pastResult);
          let pastYear = pastDate.getFullYear();
          let pastMonth = pastDate.getMonth() + 1;
          let pastDay = pastDate.getDate();

          if (pastMonth >= 1 && pastMonth <= 9) {
            pastMonth = "0" + pastMonth;
          }
          if (pastDay >= 0 && pastDay <= 9) {
            pastDay = "0" + pastDay;
          }

          this.beginTime = pastYear + '-' + pastMonth + '-' + pastDay;
        }else{

          this.dateRange = '不限时间'
          this.beginTime = ''
        }

        this.keyword = "";
        this.page = 1;
        this.currentPage = 1
        this.getReportList()

      },
    }
  }
</script>

<style scoped>
  .el-dropdown{
    cursor: pointer;
  }

  .a {
    height: 40px;
    line-height: 60px;
    background-color: #fff;
    text-align: right;
    color: #00C5B0;
    padding: 0 30px;
    text-decoration: underline;
  }

  .order-item {
    margin-bottom: 20px;
  }

  .order-item-title {
    /*width:100%;*/
    height: 40px;
    line-height: 40px;
    padding: 0 20px;
    background-color: #f5f5f5;
    text-align: left;
  }

  .state {
    display: block;
    color: #00C5B0;
    font-size: 12px;
    height: 40px;
    line-height: 40px;
  }

  .empty {
      width: 100%;
      height: 200px;
      line-height: 200px;
      text-align: center;
      background-color: #fff;
  }

  .mshow {
    display: none;
  }
  .order-item-footer{
    border: 1px solid #ebeef5;
    border-top: none;
    padding: 10px;
  }
  .foots{
    display: flex;font-size: 11px;
    margin-bottom: 10px;
    justify-content: space-between;
  }
  .footz{

    color: #999;
  }
  .footy {
    padding-right: 185px;
  }
  .footy span{
    color: #fff;
  }
  .souright{
    display:flex;
  }
  .myseh{
    display:flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  .el-button--primary {
      vertical-align: middle;box-sizing: content-box;
  }
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    .container {
      width: 95%;
    }
    /deep/ .el-loading-mask{
      z-index: 2;
    }
    .el-container {
      margin-left: 0 !important;
    }

    /deep/ .el-dialog {
      width: 98% !important;
    }
    .el-main {
      padding: 10px;
    }
    .el-table--small {
      border: 1px solid #ebeef5;
      border-bottom: none;
      border-right: none;
    }
    .el-table_6_column_22 {
      border-right: 1px solid #ebeef5;
      border-left: 1px solid #ebeef5;
    }
    .biaot {
      background-color: #F0F0F0;
      color: #333;
      font-size: 11px;
      text-align: left;
      position: relative;
      line-height: 32px;
      margin: 0 -10px 0;
      padding: 0 10px;
      border-left: 5px solid #00C5B0;
    }

    .mshow {
      display: inline-block;
    }

    .biaot div {
      position: absolute;
      right: 0;
      height: 32px;
      top: 0;
    }

    .mhide {
      display: none;
    }

    /deep/ .navbar-right-container, /deep/ .navbar-left-container img, /deep/ .hideel {
      display: none !important;
    }

    /deep/ .out {
      color: rgba(0, 196, 170, 1);
      padding-left: 0;
      margin-right: 20px;
    }
    .order-item-footer{
      border: 1px solid #ebeef5;
      border-top: none;
      padding: 10px;
    }
    .foots{
      display: flex;font-size: 11px;
      margin-bottom: 10px;
      justify-content: space-between;
    }
    .footz{

      color: #999;
    }
    .footy {
      padding-right: 9px;
    }
    .footy span{
      color: #fff;
    }

    .order-item-title{
      padding: 0 6px;
      font-size: 12px;
    }
    /deep/ .el-pager li {
      min-width: 32px;
    }
    /deep/ .el-pagination button {
      min-width: initial;
    }
    /deep/ .el-pagination .btn-prev {
      padding-right: 0;
    }
    /deep/ .el-pagination{
      margin-left: 0px;
    }

    /deep/ .el-pagination .btn-next {
      padding-left: 0;
    }
    /deep/ .el-pagination__jump {
      margin-left: 0;
      display: none!important;
    }
    /deep/ .el-table__header,/deep/ .el-table__body,/deep/ .el-table__footer{
      border-collapse: collapse;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/MyReport.vue